import { checkQtyForStock } from '../../functions/qty-check';

function ButtonChangeQtyStock(props) {
  //const props.stockAvailable = []; //sending this to qty-check will return 0 for sizes
  return (
    <div className="size-btn-box">
      {checkQtyForStock(props.stockAvailable, props.size) === 0 ? (
        <p>{props.size}</p>
      ) : (
        <p className="light-size">{props.size}</p>
      )}
      {/* <p>{props.size}</p> */}
      <div className="btn-flex-container">
        <button className="add-quantity-button" onClick={props.reduceQty}>
          <span>-</span>
        </button>
        {checkQtyForStock(props.stockAvailable, props.size) === 0 ? (
          <p>{checkQtyForStock(props.cart, props.pid, props.size)}</p>
        ) : (
          <p>
            <>{checkQtyForStock(props.stockAvailable, props.size)}</>
          </p>
        )}
        {/* <p>{checkQty(props.cart, props.pid, props.size)}</p> */}
        <button className="add-quantity-button" onClick={props.addQty}>
          <span>+</span>
        </button>
      </div>
    </div>
  );
}

export default ButtonChangeQtyStock;
